// extracted by mini-css-extract-plugin
export default {"hero":"SstfaHvO","list":"lfzxwvDU"};